<template>
    <div id="referalSignupDiv">
      <HeaderVue isHeader="true"/>
        <div class="loading">
            <div class="loading-img">
                <img src="static/images/loading.gif" alt="">
            </div>
        </div>
        <header class="reg-header">
            <div class="container">
                <div class="row">
                    <div class="col-sm-6">
                        <img src="static/images/at-home.png" class="img-fluid at-home" alt="">
                    </div>
                    <div class="col-sm-6 sec3">
                      <p>Free Home Blood Sample Collection</p>
                      <hr>
                      <p>Search Prescribed Test</p>
                      <hr>
                      <p>No Minimum value Order</p>
                      <hr>
                      <p>Access Report Online</p>
                      <hr>
                      <p>Pay Online or By Cash</p>
                      <hr>
                    </div>
                </div>
            </div>
        </header>
        <div class="wrapper">
            <div class="inner-page1 reg-content">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12">
                            <h4>
                                Labotist is an online marketplace for lab services, offering patients the convenience of
                                picking labs for their medical tests based on location, cost and turnover time. Using its
                                technology powered phlebotomy
                                kit and highly trained Phlebotomist, patients are assured safe, sophisticated and accurate
                                sample collection
                                process.
                            </h4>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-sm-6">
                            <div class="ref-form align-center p-0">
                                <img src="static/images/Register_to_get.png" class="img-fluid" alt="">
                                <p class="no-mar-top red-color" v-if="signup.error">{{signup.errormsg}}</p>
                                <p class="no-mar-top green-color" v-if="signup.success">{{signup.successmsg}}</p>
                                <form data-vv-scope="signup" v-show="!signup.success">
                                  <div class="form-content line-textbox">
                                      <h2>Create an Account with Labotist</h2>
                                    <div class="form-group">
                                        <!-- <label for="signUpEmail">Email address</label> -->
                                        <input type="email" class="form-control" id="signUpEmail" ref="signUpEmail" name="email" data-vv-as="email address" v-model="signup.email" maxlength="100" v-validate="'required|email|max:100'" placeholder="Email address">
                                        <span v-show="errors.has('signup.email')" class="text-danger">{{ errors.first('signup.email') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <!-- <label for="signUpMobile">Mobile Number</label> -->
                                        <input class="form-control" ref="signUpMobile"  type="text" name="mobile" v-mask="'##########'" data-vv-as="mobile no." v-model="signup.mobile" v-validate="'required|numeric|min:10|max:10'" placeholder="Mobile number">
                                        <span v-show="errors.has('signup.mobile')" class="text-danger">{{ errors.first('signup.mobile')}}</span>
                                    </div>
                                    <div class="form-group">
                                        <!-- <label for="firstName">Name</label> -->
                                        <input class="form-control" type="text" name="signupFirstName" data-vv-as="first name" v-model="signup.firstName" maxlength="50" v-validate="'required|alpha_spaces|max:50'" placeholder="Name">
                                        <span v-show="errors.has('signup.signupFirstName')" class="text-danger">{{ errors.first('signup.signupFirstName')}}</span>
                                    </div>
                                    <div class="form-group">
                                        <!-- <label for="password">Password</label> -->
                                        <input class="form-control" type="password" name="password" data-vv-as="password" v-model="signup.password" v-validate="'required'" placeholder="Password">
                                    <span v-show="errors.has('signup.password')" class="text-danger">{{errors.first('signup.password')}}</span>
                                    </div>
                                    <button class="btn btn-primary w-100" type="submit" @click.prevent="create_account()">Register</button>
                                  </div>
                                </form>
                                <form data-vv-scope="signupOtp" v-show="signup.success">
                                    <div class="form-group">
                                        <label for="signUpEmail">Enter OTP</label>
                                        <input class="form-control" type="text" name="sotp" data-vv-as="signup otp" v-model="signup.otp" v-validate="'required'" placeholder="Enter OTP">
                                        <span v-show="errors.has('signupOtp.sotp')" class="text-danger">{{ errors.first('signupOtp.sotp') }}</span>
                                    </div>
                                    <button class="btn btn-primary full-width mar-b-15" type="submit" @click.prevent="signup_verify_otp()">Verify</button>
                                    <a class="text-center signup-link display-block" @click.prevent="signup_resend()">Resend?</a>
                                </form>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="small-box">
                                <p>Use credit to book blood test now</p>
                                <button class="btn btn-warning w-100" v-on:click="bookNowClicked()">Book Now</button>
                            </div>
                            <ul class="test-features">
                                <li class="clearfix">
                                    <img src="static/images/icon/blood-test.png" alt="">
                                    Pick from over 1000+ blood tests
                                </li>
                                <li class="clearfix">
                                    <img src="static/images/icon/compare-cost.png" alt="">
                                    Compare cost of tests across partner labs
                                </li>
                                <li class="clearfix">
                                    <img src="static/images/icon/confort-your.png" alt="">
                                    Get blood test done from the comfort of your home
                                </li>
                                <li class="clearfix">
                                    <img src="static/images/icon/online-dashboard.png" alt="">
                                    Access to reports on an online dashboard
                                </li>
                                <li class="clearfix">
                                    <img src="static/images/icon/blood-test.png" alt="">
                                    Temperature controlled phlebotomy kit
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ignition">
                <div class="flex-container">
                    <div style="background-color:#8cc751">Hygienic</div>
                    <div style="background-color:#d7df21">Convenient</div>
                    <div style="background-color:#ffcb08">Hygienic</div>
                </div>
                <div class="ign-route">
                  <h2>How To Book</h2>
                  <img src="static/images/ignition.png" alt="">
                </div>
            </div>
            <!-- <div class="copy-right text-center">
                <p>2017 labotist . All rights received.</p>
            </div> -->
        </div>
    </div>
</template>

<script>
import HeaderVue from '@/components/mobile/Header'
// import FooterVue from '@/components/mobile/Footer'
import Sidemenu from '@/components/mobile/Public/Sidemenu'

export default {
  name: 'Privacy',
  components: {
    HeaderVue,
    Sidemenu
    // FooterVue
  },
  beforeCreate () {
  },
  created () {
      if(this.$route.params.referal_code) {
          console.log(this.$route.params.referal_code)
        try{
            this.referralCode = this.$decryptString(this.$route.params.referal_code)
            console.log(this.referralCode)
        } catch(err) {
            this.referralCode = ''
            console.log(err)
        }
      } else {
          this.$localStorage.remove('ref_code')
      }
  },
  data () {
    return {
      isDobError: false,
      otherSignup: false,
      loginWithoutBtn: false,
      login: {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      forgot: {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: '',
        otpType : ''
      },
      otp: {
        username: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: ''
      },
      signup: {
        email: '',
        mobile: '',
        firstName: '',
        password: '',
        referralCode: '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      },
      disabled: {
        from: new Date()
      },
      appointmentLogin: false,
      referralCode: '',
      referralCodeDisable: false,
    }
  },
  mounted () {
    this.$hidePageLoading()
  },
  methods: {
    create_account: function () {
       
      this.isDobError = false
      this.signup.error = false
      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          // if (this.signup.year.length !== 4 || this.signup.month.length <= 0 || this.signup.ddate.length <= 0) {
          //   this.isDobError = true
          //   return false
          // }
          try {
            if (this.signup.email !== '' && this.signup.mobile !== '' && this.signup.firstName !== '' && this.signup.password !== '') {
              let params = {
                'firstName': this.signup.firstName,
                'lastName': '',
                'phone1': this.signup.mobile,
                'email': this.signup.email,
                'password': this.signup.password,
                'referralCode': this.referralCode,
                // 'sex': this.signup.sex,
                'sex': '',
                // 'dob': this.signup.year + '-' + this.signup.month + '-' + this.signup.ddate,
                'dob': null
                // 'dob': dateFormat(this.signup.dob, 'yyyy-mm-dd', true)
              }
              Promise.resolve(this.$POST('patient/quickSignUp', params)).then(function (response) {
                if (response.response_code === 0) {
                  this.signup.error = false
                  this.signup.errormsg = ''
                  this.signup.success = true
                  this.signup.successmsg = 'We have send an authentication code for verifying your account.'
                  Vue.analytics.fbq.event('ViewContent', {
                    content_ids: 0,
                    content_name: 'SIGN UP SUCCESS',
                    contents: '',
                    content_type: 'SIGNUP_SUCCESS'
                  })
                } else {
                  this.signup.success = false
                  this.signup.error = true
                  this.signup.errormsg = response.response_message
                  this.signup.otp = ''
                  if(response.response_code === 3) {
                      this.$refs.signUpEmail.focus()
                    } else if(response.response_code === 4) {
                      this.$refs.signUpMobile.focus()
                    }
                }
              }.bind(this)).catch(function (err) {
                console.log(err)
              })
            } else {
              this.$Simplert.open({
                title: 'Alert',
                message: `Please enter required fields!`,
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              })
              // alert('Please enter required fields!')
            }
          } catch (e) {
            console.error(e)
          }
        }
      }.bind(this))
    },
    signup_verify_otp: function () {
      this.$validator.validateAll('signupOtp').then((result) => {
        if (result) {
          if (this.signup.email !== '' && this.signup.otp !== '') {
            this.$verifyOTP(this.signup.email, this.signup.otp).then(function (response) {
              if (response.error) {
                this.signup.error = true
                this.signup.errormsg = 'Invalid OTP'
                this.signup.successmsg = ''
                return false
              } else {
                if (this.appointmentLogin) {
                  this.appointmentLogin = false
                  this.$root.$emit('isLogin', true)
                //   $('.signup').modal('hide')
                  this.$router.push('/address')
                  // location.reload()
                  return false
                } else {
                  this.$root.$emit('isLogin', true)
                  $('.signup').modal('hide')
                  // location.reload()
                  // this.$router.push('/myprofile')
                  this.$router.push({path:'/referral/landing'})
                }
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          }
        }
      })
    },
    signup_resend: function () {
      try {
        if (this.signup.email !== '') {
          let data = {
            'email': this.signup.email
          }
          Promise.resolve(this.$POST('patient/resendOTP', data)).then(function (res) {
            if (res.response_code === 0) {
              this.signup.error = false
              this.signup.errormsg = ''
              this.signup.success = true
              this.signup.successmsg = 'We have resend an authentication code to your mail id.'
            } else {
              this.signup.success = false
              this.signup.error = true
              this.signup.errormsg = res.response_message
              this.signup.otp = ''
            }
          }.bind(this)).catch(function (err) {
            console.log(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    bookNowClicked : function() {
        if (this.referralCode && this.referralCode.length > 0) {
            this.$localStorage.set('ref_code', this.referralCode)
        } else {
            this.$localStorage.remove('ref_code')
        }
        this.$router.push('/lab')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mobile/Public/ReferalSignup.vue